import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { Button } from "../../../components/button/button";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { Policy } from "../../policy/policy";

export const AdminDocumentsPage = () => {
    const navigate = useAnimatedNavigate();

    return (
        <>
            <AdminHeader title="Документы" />

            <Policy />

            <Button
                text="Вернуться"
                onClick={() => navigate(-1)}
            />
        </>
    );
}